var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home pt-5"},[_c('BannerMultiProductComponent',{attrs:{"items":_vm.banner_items[_vm.$props.lang],"lang":_vm.$props.lang}}),_c('products',{attrs:{"lang":_vm.$props.lang,"currency":"USD","alone":"products"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }